import { authFetch } from "api";

export const getPersonsByClientId = async (clientId) => {
    const httpResponse = await authFetch(`/api/person?clientId=${clientId}`);
    if (httpResponse.ok) {
        return await httpResponse.json();
    }
    throw httpResponse;
}